import { createRouter, createWebHistory } from 'vue-router'
import Index from "../components/Index.vue"
import Callback from "../components/Callback.vue"
import Loginform from "../components/Loginform.vue"
import XDLocalStorageIframe from "../components/XDLocalStorageIframe.vue"

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index
    },
    {
      path: "/login",
      name: "Callback",
      component: Callback
    },
    {
      path: "/loginform",
      name: "Loginform",
      component: Loginform
    },
    {
      path: "/xdlocalstorage-iframe",
      name: "XDLocalStorageIframe",
      component: XDLocalStorageIframe
    }
  ]
})

export default router
